export type RequestCallbacksParams<T = unknown> = {
  afterSuccess?: (data?: T) => void;
  afterError?: (data?: T) => void;
  afterEvery?: () => void;
  afterAll?: () => void;
};

export enum AutoConnectStatus {
  NoInitialSelection,
  InitialSelectionAutoConnect,
  InitialSelectionPaymentMethodOnly,
  InitialSelectionSetupLater,
  Enabled,
  Disabled
}

export enum TransactionErrorType {
  Internal = 'Internal',
  InsufficientFunds = 'InsufficientFunds',
  Connection = 'Connection',
  ThirdParty = 'ThirdParty',
  CardDeclined = 'CardDeclined',
  PaymentMethodNotFound = 'PaymentMethodNotFound'
}

export interface ICompany {
  readonly aionOrganizationId: string;
  readonly companyType: string;
  readonly companyId: string;
  companyName: string;
  shortName: string;
  taxPayerIdNumber: string;
}

export interface IPendingConnection {
  id: string;
  requestType: number;
  dateRequested: string;
  contractorId: string;
  organizationId: string;
  organizationName: string;
  organizationCompanyId: number;
}

export enum ConnectionType {
  Incoming = 0,
  Outgoing = 1,
  Active = 2
}

export type ZuoraIframe = {
  Z: {
    render(...args: any[]): void;
  };
} & Window &
  typeof globalThis;

export type ZuoraIframeSignature = {
  key: string;
  signature: string;
  tenantId: string;
  token: string;
  field_accountId: string;
  locale: string;
  style: string;
  submitEnabled: string;
  id: string;
  url: string;
};

export type ZuoraIFrameSignatureTypes = {
  ACH?: ZuoraIframeSignature;
  CreditCard?: ZuoraIframeSignature;
};

export enum PaymentMethodType {
  ACH = 'ACH',
  CreditCard = 'CreditCard'
}

export enum PrimaryContactType {
  Billing = 'Billing',
  Company = 'Company',
  New = 'New'
}

export interface IConnectionBillingPreview {
  organizationId: string;
  organizationName: string;
  type: number;
  ordinal: number;
  price: number;
  isPotentiallyFreeConnection: boolean;
  isPartiallyFreeConnection: boolean;
  isFreeConnection: boolean;
  requested: boolean;
}

export enum BillingErrorType {
  PaymentDetails = 'PaymentDetails',
  SetDefaultMethod = 'SetDefaultMethod',
  BillingPreview = 'BillingPreview',
  FetchPaymentMethods = 'FetchPaymentMethods',
  VerifyFunds = 'VerifyFunds',
  ZuoraIframe = 'ZuoraIframe',
  IncomingConnections = 'IncomingConnections'
}
